import Button from "./Button";
import Dialog from "./Dialog";

interface Props {
  open: boolean;
  onClose: () => void;
}

const UpgradeDialog = ({ open, onClose }: Props) => {
  return (
    <Dialog
      open={open}
      size="small"
      onClose={() => {
        onClose();
      }}
    >
      <Dialog.Title>Upgrade for Full Access</Dialog.Title>
      <Dialog.Content>Access all features without limits.</Dialog.Content>
      <Dialog.Footer>
        <Button
          type="accent_secondary"
          buttonProps={{
            onClick: onClose,
          }}
        >
          Cancel
        </Button>
        <Button
          type="accent"
          buttonProps={{
            type: "submit",
            onClick: () => {
              // TODO
            },
          }}
        >
          Upgrade
        </Button>
      </Dialog.Footer>
    </Dialog>
  );
};

export default UpgradeDialog;
